export default "__VITE_ASSET__Buef4j_F__"